// extracted by mini-css-extract-plugin
export default {"dialog":"UpgradeInfoModal_dialog__1LW8M"};